import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import { Modal, Button, Spinner, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../Api';

function WorkOrderClosed() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await api.get(`/work-orders/${id}/details`);
        if (res.data.success) {
          setDetail(res.data);
        } else {
          toast.error('Gagal memuat detail tiket');
        }
      } catch (err) {
        toast.error('Terjadi kesalahan saat memuat data!');
      } finally {
        setLoading(false);
      }
    };
    fetchDetail();
  }, [id]);

  const handlePreview = (img) => {
    setPreviewImg(img);
    setShowPreview(true);
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!detail) return <div className="alert alert-danger">Data tidak ditemukan</div>;

  // =========================
  // CLUSTERING DATA
  // =========================

  const dataTiket = {
    no_tiket: detail.external_ref,
    kategori: detail.category,
    keluhan: detail.description,
    priority: detail.priority,
    status: detail.status,
    tgl_buat: detail.created_at,
    tgl_ambil: detail.details?.[0]?.approved_at,
    tgl_closed: detail.details?.find((d) => d.status_detail === 'closed')?.updated_at,
  };

  const dataPelanggan = {
    id_pelanggan: detail.id_pelanggan,
    nama: detail.nama,
    alamat: detail.alamat,
    no_hp: detail.no_hp,
    status: detail.customer,
  };

  const dataPetugas = detail.details || [];

  const formatTanggal = (dateString) => {
    if (!dateString) return '-';

    const date = new Date(dateString);

    return (
      date.toLocaleString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Asia/Jakarta',
      }) + ' WIB'
    );
  };

  return (
    <>
      <div className="container mt-4">
        <div className="card shadow">
          <div className="card-header" style={{ backgroundColor: '#1a237e' }}>
            <h5 className="mb-0 text-white">Detail Work Order - {dataTiket.no_tiket}</h5>
          </div>

          <div className="card-body">
            {/* ===================== */}
            {/* CLUSTER 1 - DATA TIKET */}
            {/* ===================== */}
            {/* BUTTON BACK */}
            <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
              <ArrowLeft size={16} /> Kembali
            </button>
            <h6 className="fw-bold text-primary mt-4 mb-3">Data Tiket</h6>
            <table className="table table-bordered mb-4">
              <tbody>
                <tr>
                  <th>Kategori</th>
                  <td>{dataTiket.kategori}</td>
                  <th>Priority</th>
                  <td>
                    <Badge
                      bg={
                        dataTiket.priority === 'critical'
                          ? 'danger'
                          : dataTiket.priority === 'medium'
                            ? 'warning'
                            : 'success'
                      }
                    >
                      {dataTiket.priority}
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <th>Keluhan</th>
                  <td colSpan="3">{dataTiket.keluhan}</td>
                </tr>
                <tr>
                  <th>Tgl Buat</th>
                  <td>{formatTanggal(dataTiket.tgl_buat)}</td>
                  <th>Tgl Ambil</th>
                  <td>{formatTanggal(dataTiket.tgl_ambil)}</td>
                </tr>
                <tr>
                  <th>Tgl Closed</th>
                  <td>{formatTanggal(dataTiket.tgl_closed)}</td>
                  <th>Status</th>
                  <td>{dataTiket.status}</td>
                </tr>
              </tbody>
            </table>

            {/* ===================== */}
            {/* CLUSTER 2 - DATA PELANGGAN */}
            {/* ===================== */}
            <h6 className="fw-bold text-primary mt-4 mb-3">Data Pelanggan</h6>
            <table className="table table-bordered mb-4">
              <tbody>
                <tr>
                  <th>ID Pelanggan</th>
                  <td>{dataPelanggan.id_pelanggan}</td>
                  <th>Status</th>
                  <td>{dataPelanggan.status}</td>
                </tr>
                <tr>
                  <th>Nama</th>
                  <td>{dataPelanggan.nama}</td>
                  <th>No HP</th>
                  <td>{dataPelanggan.no_hp}</td>
                </tr>
                <tr>
                  <th>Alamat</th>
                  <td colSpan="3">{dataPelanggan.alamat}</td>
                </tr>
              </tbody>
            </table>

            {/* ===================== */}
            {/* CLUSTER 3 - PETUGAS & KASIE */}
            {/* ===================== */}
            <h6 className="fw-bold text-primary mt-4 mb-3">Data Petugas & Kasie</h6>

            {dataPetugas.map((item) => (
              <div key={item.id} className="card mb-3 border">
                <div className="card-body">
                  <p>
                    <strong>Nama Petugas:</strong> {item.username}
                  </p>
                  <p>
                    <strong>Status Detail:</strong> {item.status_detail}
                  </p>
                  <p>
                    <strong>Nama Kasie:</strong> {item.kasie?.username || '-'}
                  </p>

                  {/* ===================== */}
                  {/* CLUSTER 4 - FOTO */}
                  {/* ===================== */}
                  <div className="row mt-3">
                    {item.media?.length > 0 ? (
                      item.media.map((m) => (
                        <div className="col-md-3 mb-3" key={m.id}>
                          <div className="card">
                            <img
                              src={m.media_url}
                              alt="bukti"
                              className="img-fluid"
                              style={{ cursor: 'pointer' }}
                              onClick={() => handlePreview(m.media_url)}
                            />
                            <div className="card-body p-2">
                              <small>
                                <strong>Tipe:</strong> {m.type}
                                <br />
                                <strong>Captured:</strong> {m.captured_at}
                              </small>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">Tidak ada foto untuk petugas ini</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* MODAL PREVIEW */}
      <Modal show={showPreview} onHide={() => setShowPreview(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Preview Foto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImg && <img src={previewImg} alt="preview" className="img-fluid rounded" />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPreview(false)}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default WorkOrderClosed;
